import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative w-full h-full flex items-center" }
const _hoisted_2 = { class: "p-px pr-0 absolute left-0 transform top-1/2 -translate-y-1/2 h-full" }
const _hoisted_3 = { class: "bg-gray-lp-1000 flex items-center justify-center w-12 h-full rounded-l-md cursor-pointer" }
const _hoisted_4 = { class: "flex items gap-x-2.5 rounded-r-md pr-4" }
const _hoisted_5 = { class: "text-sm text-black-lp-300 font-medium font-montserrat" }
const _hoisted_6 = { class: "text-sm text-black-lp-300 font-medium font-montserrat" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex items-center w-full h-full border bg-white rounded-md", {
        'border-red-lp-100': _ctx.isSelected,
        'border-gray-lp-900': !_ctx.isSelected
      }]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Icons, {
            name: "drag-indicator",
            class: "w-4 text-gray-lp-600"
          })
        ])
      ]),
      _createVNode("textarea", {
        value: _ctx.data.templateMessage,
        ref: "templateEdit",
        maxlength: _ctx.maxLengthNewTemplate,
        placeholder: _ctx.$t('pusatResolusi.create.descPlaceholder'),
        class: ["w-full resize-none overflow-hidden pl-16 pr-8 py-3 outline-none leading-tight h-auto caret-red-lp-100 rounded-md", {
          'cursor-default': !_ctx.isSelected
        }],
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInputEdit && _ctx.onInputEdit(...args))),
        onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnter && _ctx.handleEnter(...args)), ["enter"])),
        onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitEdit && _ctx.onSubmitEdit(...args))),
        readonly: !_ctx.isSelected
      }, null, 42, ["value", "maxlength", "placeholder", "readonly"]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleTooltipDelete($event))),
          onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleTooltipDelete($event)))
        }, [
          _createVNode(_component_Icons, {
            id: `button_delete_pesan_cepat_${_ctx.index}`,
            name: "white-trash",
            class: "w-4 text-gray-lp-600 hover:text-red-lp-100 cursor-pointer",
            onClick: _cache[4] || (_cache[4] = () => _ctx.onConfirmDelete(_ctx.data))
          }, null, 8, ["id"]),
          _createVNode(_component_OverlayPanel, {
            ref: `tooltipDelete`,
            appendTo: "body"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('pusatResolusi.deleteMessage')), 1)
            ]),
            _: 1
          })
        ], 32),
        _createVNode("div", {
          onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toggleTooltipEdit($event))),
          onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleTooltipEdit($event))),
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)), ["prevent"]))
        }, [
          _createVNode(_component_Icons, {
            id: `button_delete_pesan_cepat_${_ctx.index}`,
            name: "pencil-edit-no-square",
            class: ["w-4 hover:text-red-lp-100 cursor-pointer", {
              'text-red-lp-100': _ctx.isSelected,
              'text-gray-lp-600': !_ctx.isSelected
            }]
          }, null, 8, ["id", "class"]),
          _createVNode(_component_OverlayPanel, {
            ref: `tooltipEdit`,
            appendTo: "body"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('pusatResolusi.editMessage')), 1)
            ]),
            _: 1
          })
        ], 32)
      ])
    ], 2)
  ]))
}